module.exports = __webpack_public_path__ + "img/expired.58189043.svg";